import { render, staticRenderFns } from "./FilterClaimType.vue?vue&type=template&id=176ba9e4&scoped=true&lang=pug&"
import script from "./FilterClaimType.vue?vue&type=script&lang=js&"
export * from "./FilterClaimType.vue?vue&type=script&lang=js&"
import style0 from "./FilterClaimType.vue?vue&type=style&index=0&id=176ba9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ba9e4",
  null
  
)

export default component.exports